import { useEffect, useState } from 'react'
import { cn } from '@/lib/utils'
import { apiListCampaigns } from '@/lib/api'
import { buildWelcomeText, getFirstName } from '@/lib/chatFormat'
import { AgentMarker } from '@/components/agents/AgentMessage'

export type WelcomeMessageProps = {
  name?: string | null
  email: string
  className?: string
}

// Message d'accueil contextuel (affichage pur : jamais persisté ni envoyé au
// LLM). Le résumé « N campagnes actives » est best effort : en cas d'échec,
// aucun résumé et aucun toast (décision PO Q4).
export function WelcomeMessage({ name, email, className }: WelcomeMessageProps) {
  const [activeCount, setActiveCount] = useState<number | null>(null)

  useEffect(() => {
    let cancelled = false
    void (async () => {
      try {
        const campaigns = await apiListCampaigns({ status: 'ACTIVE' })
        if (!cancelled && Array.isArray(campaigns)) setActiveCount(campaigns.length)
      } catch (e: unknown) {
        // Silencieux : le message d'accueil s'affiche sans résumé.
        void e
      }
    })()
    return () => {
      cancelled = true
    }
  }, [])

  const text = buildWelcomeText(getFirstName(name, email), activeCount)

  return (
    <div className={cn('flex flex-col items-start gap-1.5', className)} data-testid="agent-welcome">
      <AgentMarker />
      <div className="w-full max-w-[90%] rounded-2xl rounded-tl-sm border border-slate-100 bg-[var(--chat-assistant-bg)] px-4 py-3 text-sm leading-relaxed text-slate-800 shadow-sm">
        {text}
      </div>
    </div>
  )
}
